import Api from '@/api/clinique/_clinique.js'

export default {
    addAssurance(data) {
        const promise = Api().post('/assurances/store', data)
        return promise.then((response) => response.data)
    },
}